/**
 * BULK OPERATIONS — пакетный выбор и удаление услуг.
 *
 * Phase 5 modularization (Sprint 6, 2026-05-07).
 * Извлечено из public/js/app.js (DOMAIN: BULK OPERATIONS).
 *
 * Состояние выбора хранится в `this.state.selectedServices` (Set<serviceId>).
 * UI bulk-controls появляется в #bulk-controls-container когда выбрано
 * хотя бы одно сервис; при пустом наборе контейнер очищается.
 *
 * @module app/bulk-operations
 */

/**
 * Прикрепляет методы пакетных операций к prototype класса.
 * @param {Function} ClassRef - класс ProfessionalQuoteCalculator
 */
export function attachBulkOperations(ClassRef) {
    Object.assign(ClassRef.prototype, {
        toggleServiceSelection(serviceId) {
            if (this.state.selectedServices.has(serviceId)) {
                this.state.selectedServices.delete(serviceId);
            } else {
                this.state.selectedServices.add(serviceId);
            }

            // Update visual state and controls efficiently
            const serviceCard = document.querySelector(`[data-service-id="${serviceId}"]`);
            const checkbox = document.querySelector(`input[data-service-id="${serviceId}"]`);

            if (serviceCard && checkbox) {
                const isSelected = this.state.selectedServices.has(serviceId);
                serviceCard.classList.toggle('selected', isSelected);
                checkbox.checked = isSelected;
            }

            this.debouncedBulkUpdate();
        },

        toggleSelectAll() {
            const allSelected = this.state.selectedServices.size === this.state.services.length && this.state.services.length > 0;

            if (allSelected) {
                this.state.selectedServices.clear();
            } else {
                this.state.services.forEach(service => {
                    this.state.selectedServices.add(service.id);
                });
            }

            // Update all checkboxes and cards efficiently
            document.querySelectorAll('.service-checkbox').forEach(checkbox => {
                const serviceId = checkbox.dataset.serviceId;
                const isSelected = this.state.selectedServices.has(serviceId);
                checkbox.checked = isSelected;

                const serviceCard = checkbox.closest('.service-card');
                if (serviceCard) {
                    serviceCard.classList.toggle('selected', isSelected);
                }
            });

            this.updateBulkControls();
        },

        updateBulkControls() {
            const selectedCount = this.state.selectedServices.size;
            const totalCount = this.state.services.length;
            const container = document.getElementById('bulk-controls-container');

            if (!container) return;

            if (selectedCount > 0) {
                // Создаем или обновляем bulk controls
                const selectAllText = selectedCount === totalCount ? 'Снять все' : 'Выбрать все';
                container.innerHTML = `
                    <div class="bulk-controls" id="bulk-controls">
                        <div class="selection-counter">Выбрано: ${selectedCount} из ${totalCount} услуг</div>
                        <button class="btn btn-sm" onclick="window.QuoteCalc.toggleSelectAll()" id="select-all-btn">${selectAllText}</button>
                        <button class="btn btn-sm btn-warning" onclick="window.QuoteCalc.deleteSelected()" id="delete-selected-btn">Удалить выбранные</button>
                    </div>
                `;
            } else {
                // Полностью удаляем из DOM
                container.innerHTML = '';
            }
        },

        deleteSelected() {
            if (this.state.selectedServices.size === 0) return;

            const selectedCount = this.state.selectedServices.size;

            // Add confirmation dialog
            if (!confirm(`Удалить ${selectedCount} услуг? Это действие нельзя отменить.`)) {
                return;
            }

            this.state.services = this.state.services.filter(service =>
                !this.state.selectedServices.has(service.id)
            );

            this.state.selectedServices.clear();
            this.renderServices();
            this.updateBulkControls();
            this.scheduleUpdate();
            this.markQuoteAsUnsaved();

            this.showNotification(`Удалено ${selectedCount} услуг`);
        }
    });
}
